module.exports = __webpack_public_path__ + "static/media/maintenance.f1356e61.svg";